// JobClose AI · Roadmap #2 · Strategy A native-shell detection.
//
// Single authoritative source for "is this render happening inside the
// Capacitor-wrapped native (iOS/Android) shell?"  Used to hide every
// commercial surface (Stripe checkout, tier pricing, launch offer,
// setup packages, Website Starter, Enterprise sales CTA, Manage
// Billing / Stripe portal, /pricing route, subscription pricing inside
// signup) on native without touching the web experience.
//
// Detection strategy · deliberately runtime-only.
// Capacitor injects ``window.Capacitor`` at boot in the native
// WebView; its ``isNativePlatform()`` returns true on iOS + Android,
// false in a browser tab.  Reading it via ``window`` avoids importing
// ``@capacitor/core`` from every gated component, which keeps the
// dependency-free web bundle unchanged and keeps unit tests trivial
// (tests just mutate ``globalThis.window.Capacitor``).
//
// Web (Capacitor absent, or ``isNativePlatform`` returns false):
// returns ``false``.  Native (iOS/Android WebView): returns ``true``.
// Any thrown error (defensive) also collapses to ``false`` so a
// broken detection never accidentally hides commercial surfaces from
// paying web contractors.

export const isNativeShell = () => {
  try {
    if (typeof window === "undefined") return false;
    const cap = window.Capacitor;
    if (!cap) return false;
    if (typeof cap.isNativePlatform === "function") {
      return cap.isNativePlatform() === true;
    }
    return false;
  } catch {
    return false;
  }
};

export const __internals = { isNativeShell };
